<template>
  <div id="evaluation">
    <div class="wrap">
      <popups text="感谢您的反馈" anonymous="hide" @onOff="$emit('onOff', 'evaluation')" @confirm="confirm">
        <div class="content">
          <div class="content-title">请为小管子此次的问题解答评级</div>
          <div class="star-list">
            <div class="star-item" v-for="(star, index) in starItem" :key="star.id" :class="{'star-active': star.isActive}" @click="selectStar(index)"></div>
          </div>
        </div>
      </popups>
    </div>
  </div>
</template>

<script>
import popups from '../popups/popups'

export default {
  name: 'evaluation',
  data () {
    return {
      starItem: [
        {id: 0, isActive: false},
        {id: 1, isActive: false},
        {id: 2, isActive: false},
        {id: 3, isActive: false},
        {id: 4, isActive: false}
      ],
      starNum: 0
    }
  },
  components: {
    popups
  },
  methods: {
    selectStar (num) {
      this.starNum = num + 1
      this.starItem.forEach((star, index) => {
        if (num >= index) {
          star.isActive = true
        } else {
          star.isActive = false
        }
      })
    },
    confirm () {
      if (this.starNum !== 0) {
        this.$emit('confirm', this.starNum, 'evaluation')
      } else {
        this.$message({
          showClose: true,
          message: '您还未选择评级',
          type: 'warning'
        })
      }
    }
  }
}
</script>

<style scoped>
#evaluation {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
}
.wrap {
  box-sizing: border-box;
  position: fixed;
  left: 50%;
  top: 50%;
  z-index: 1000;
  transform: translate(-50%, -50%);
  width: 580px;
  height: 268px;
  padding: 38px 40px 40px 41px;
  background: #fff;
}

.content {
}
.content-title {
  height: 21px;
  margin-top: 29px;
  font-size: 15px;
  color: #999999;
  line-height: 21px;
  letter-spacing: -0.36px;
}
.star-list {
  display: flex;
  height: 35px;
  margin-top: 15px;
  margin-bottom: 45px;
}
.star-item {
   width: 37px;
   height: 35px;
   margin-right: 18.6px;
   background: #fff url("../../icons/star-gray.svg") no-repeat center;
  cursor: pointer;
 }
.star-active {
  background: #fff url("../../icons/star-yellow.svg") no-repeat center;
}
.av {}
</style>



// WEBPACK FOOTER //
// src/components/evaluation/evaluation.vue